export const useSearchStore = defineStore('search', () => {
  const searchValue = ref('')
  const setSearchValue = (newValue: string) => {
    searchValue.value = newValue
  }
  return { setSearchValue, searchValue }
})
